import * as React from "react";
import { useSelector } from "react-redux";
import { Loader } from "semantic-ui-react";

import { ApplicationState } from "../../../applicationState";
import { taskIdSelector, taskSelector } from "../../selectors";

import { CreateRecallModal } from "./CreateRecallModal";

export const CreateRecall: React.FunctionComponent = () => {

    const task = useSelector(taskSelector);
    const isModalOpen = useSelector((state: ApplicationState) => taskIdSelector(state) === task?.id);

    if (task) {
        return (
            <CreateRecallModal customerId={task.customer.id} ohCaseId={task.caseId} taskId={task.id} open={isModalOpen} />
        );
    }

    return <Loader active />;
};
